





























































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import OnceButton from '@/components/OnceButton.vue';

@Component({
  components: {
    OnceButton
  }
})
export default class RevokeConfirmDialog extends Vue {
  @Prop({ required: true })
  readonly value!: boolean;
  @Prop({ required: true })
  readonly isRegistOpCard!: boolean;
  @Prop({ required: true })
  readonly isRevokeCardDigital!: boolean;
  @Prop({ required: true })
  readonly isPointOnlyRealCard!: boolean;
  @Prop({ required: true })
  readonly buttonLoading!: boolean;
  @PropSync('doUnsubscribeOpCard', { type: Boolean, required: true })
  syncedDoUnsubscribeOpCard!: Boolean;

  get wrapperDialog() {
    return this.value;
  }

  set wrapperDialog(flag: boolean) {
    this.$emit('input', flag);
  }

  cancel() {
    this.$emit('cancel');
    this.$emit('input', false);
  }
}
